import TravelRaterPriceRequest from '@/modules/travel/common/models/MID/requests/TravelRaterPriceRequest'
import CommonMapper from '@/modules/core/mappers/CommonMapper'
import type TravelRaterAnswers from '@/modules/travel/rater/models/APP/TravelRaterAnswers'
import type TravelHiringAnswers from '@/modules/travel/hiring/models/APP/TravelHiringAnswers'

export default class GetPricingMapper {
  static toRequest(
    data: TravelRaterAnswers | TravelHiringAnswers,
    isQuote: boolean = false,
    mediator?: string
  ): TravelRaterPriceRequest {
    const clientProducts = []
    if (data?.product) {
      clientProducts.push({
        clientCode: data?.product.clientCode,
        productCode: data?.product.productCode
      })
    }

    return new TravelRaterPriceRequest({
      businessLine: data.businessLine,
      insuranceStartDate: CommonMapper.toMiddlewareDate(data.departureDate),
      insuranceType: data.insuranceType,
      destinationType: data.destinationType,
      departureDate: CommonMapper.toMiddlewareDate(data.departureDate),
      returnDate: CommonMapper.toMiddlewareDate(data.returnDate),
      numberTravelers: data.forWhomPeople,
      sportInsurance: data.sportInsurance,
      quotationId: data.quotationId || undefined,
      quotationNumber: data.product?.quotationNumber || undefined,
      clientProducts: clientProducts.length ? clientProducts : null,
      allowsCancellation: data.cancellationCoverage,
      isQuote,
      mediator
    })
  }
}
